module.exports = __webpack_public_path__ + "static/logo-fb8a6624f2f6521cff5d57f560e9ea10.png";